export default __webpack_public_path__ + "static/media/screen.fed34d32.png";